import { db } from "../firebase-config"
import { collection, getDocs, doc, addDoc, query, where, deleteDoc, updateDoc } from "firebase/firestore"

const auth = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzM4NCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiYWRtaW4iOnRydWUsImlhdCI6MTY0MDE5NDkyNiwiZXhwIjoxNjQwMTk4NTI2fQ.2OeyyGVlT44pNPUXzs5JeC7jTK48GehzAr5MdlgwmMJzBByUoWqLK6N-SYo896uf'
const axios = require('axios').default;
const apiURL = 'https://southamerica-east1-portal-gerenciador.cloudfunctions.net/firebaseAdminAuth'

const config = {
  headers: {
    Authorization: auth,
  }
}

export const generatePassword = (passLength) => {
  var text = ""
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"
  possible += "01234567890123456789012345678901234567890123456789"
  for (var i = 0; i < passLength; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  return text
}

export const addUserPermissions = async (user) => {
  user.permission ? user.permission : 'padrao'
  try {
    const queryPermission = collection(db, "permission-user")
    const q = query(queryPermission, where("email", "==", user.email))
    const docs = await getDocs(q)
    if (docs.size > 0) {
      return { aviso: 'Usuário já possui permissões' }
    }
    const newUser = {
      "email": user.email,
      "password": generatePassword(10),
      "displayName": user.email.split('@', 1).join().split('.').join(" ").replace(/(\b[a-z](?!\s))/g, (c) => c.toUpperCase())
    }
    axios.post(`${apiURL}/addUser`, newUser, config)
      .then(
        await addDoc(collection(db, "permission-user"), user)
      );
    return {
      aviso: 'Usuário adicionado ao sistema!',
      usuario: user.email,
      senha: newUser.password,
    }
  } catch (e) {
    console.error(e)
  }
}

export const removeUserPermissions = async (item) => {
  try {
    axios.post(`${apiURL}/deleteUser`, { email: item.email }, config)
      .then(await deleteDoc(
        doc(
          db,
          "permission-user",
          item.id
        )
      ))
    return {
      aviso: 'Usuário removido com sucesso!'
    }
  } catch (e) {
    console.error(e)
  }
}

export const findAllUsers = async (email = '') => {
  const userArray = []
  try {
    let queryAll = collection(db, "permission-user")
    if (email != '')
      queryAll = query(queryAll, where("email", "==", email))
    const docs = await getDocs(queryAll)
    docs.forEach((doc) => {
      let arrayData = doc.data()
      arrayData.id = doc.id
      userArray.push(arrayData)
    })
    return userArray
  } catch (e) {
    console.error(e)
  }
}

export const findUserByMail = async (email) => {
  try {
    let user
    const queryPermission = collection(db, "permission-user")
    const q = query(queryPermission, where("email", "==", email))
    const docs = await getDocs(q)
    docs.forEach((doc) => {
      user = doc.data()
      user.id = doc.id
    })
    return user
  } catch (e) {
    console.error(e)
  }
}

export const updateUserInfo = async (id, data) => {
  try {
    const updateRef = doc(db, "permission-user", id)
    updateDoc(
      updateRef,
      data
    )
    return {
      aviso: 'Usuário atualizado com sucesso!'
    }
  } catch (e) {
    console.error(e)
  }
}
